import React, { Fragment } from 'react';

import { Button } from '@material-ui/core';

export default function LivePreviewExample() {
  return (
    <Fragment>
      <Button
        color="inherit"
        className="m-2 text-black btn-gradient btn-gradient-inverse bg-warm-flame">
        Warm Flame
      </Button>
      <Button
        color="inherit"
        className="m-2 text-black btn-gradient btn-gradient-inverse bg-night-fade">
        Night Fade
      </Button>
      <Button
        color="inherit"
        className="m-2 text-black btn-gradient btn-gradient-inverse bg-sunny-morning">
        Sunny Morning
      </Button>
      <Button
        color="inherit"
        className="m-2 text-black btn-gradient btn-gradient-inverse bg-tempting-azure">
        Tempting Azure
      </Button>
      <Button
        color="inherit"
        className="m-2 text-black btn-gradient btn-gradient-inverse bg-amy-crisp">
        Amy Crisp
      </Button>
      <Button
        color="inherit"
        className="m-2 text-black btn-gradient btn-gradient-inverse bg-heavy-rain">
        Heavy Rain
      </Button>
      <Button
        color="inherit"
        className="m-2 text-black btn-gradient btn-gradient-inverse bg-mean-fruit">
        Mean Fruit
      </Button>
      <Button
        color="inherit"
        className="m-2 text-black btn-gradient btn-gradient-inverse bg-malibu-beach">
        Malibu Beach
      </Button>
      <Button
        color="inherit"
        className="m-2 text-black btn-gradient btn-gradient-inverse bg-deep-blue">
        Deep Blue
      </Button>
      <Button
        color="inherit"
        className="m-2 text-white btn-gradient bg-ripe-malin">
        Ripe Malin
      </Button>
      <Button
        color="inherit"
        className="m-2 text-white btn-gradient bg-arielle-smile">
        Arielle Smile
      </Button>
      <Button
        color="inherit"
        className="m-2 text-white btn-gradient bg-plum-plate">
        Plum Plate
      </Button>
      <Button
        color="inherit"
        className="m-2 text-black btn-gradient btn-gradient-inverse bg-happy-fisher">
        Happy Fisher
      </Button>
      <Button
        color="inherit"
        className="m-2 text-white btn-gradient bg-happy-itmeo">
        Happy Itmeo
      </Button>
      <Button
        color="inherit"
        className="m-2 text-white btn-gradient bg-mixed-hopes">
        Mixed Hopes
      </Button>
      <Button
        color="inherit"
        className="m-2 text-white btn-gradient bg-strong-bliss">
        Strong Bliss
      </Button>
      <Button
        color="inherit"
        className="m-2 text-white btn-gradient bg-grow-early">
        Grow Early
      </Button>
      <Button
        color="inherit"
        className="m-2 text-white btn-gradient bg-love-kiss">
        Love Kiss
      </Button>
      <Button
        color="inherit"
        className="m-2 text-white btn-gradient bg-premium-dark">
        Premium Dark
      </Button>
      <Button
        color="inherit"
        className="m-2 text-white btn-gradient bg-happy-green">
        Happy Green
      </Button>
      <Button
        color="inherit"
        className="m-2 text-white btn-gradient bg-vicious-stance">
        Vicious Stance
      </Button>
      <Button
        color="inherit"
        className="m-2 text-white btn-gradient bg-midnight-bloom">
        Midnight Bloom
      </Button>
      <Button
        color="inherit"
        className="m-2 text-white btn-gradient bg-night-sky">
        Night Sky
      </Button>
      <Button
        color="inherit"
        className="m-2 text-white btn-gradient bg-slick-carbon">
        Slick Carbon
      </Button>

      <Button color="inherit" className="m-2 text-white btn-gradient bg-royal">
        Royal
      </Button>
      <Button
        color="inherit"
        className="m-2 text-white btn-gradient bg-asteroid">
        Asteroid
      </Button>
    </Fragment>
  );
}
